import * as React from 'react';
import { SiteVariablesPrepared } from "@fluentui/react-northstar";
import { IChartData } from "../chart-types";
import BarHorizontalChart from "./bar-horizontal";

export const BarHorizontalStackedChart = ({
	title,
	data,
	siteVariables,
}: {
	title: string;
	data: IChartData;
	siteVariables: SiteVariablesPrepared;
}) => (
	<BarHorizontalChart
		{
		...{
			title,
			data,
			siteVariables,
			stacked: true,
		}
		}
	/>
);
